import React, { useState, useEffect } from "react";
import { Tab, Tabs, Typography } from "@mui/material";
import moment from "moment";
import HomeVisitsReport from "./HomeHealthcareReports/HomeVisitsReport";
import ShiftChangeLogsReport from "./HomeHealthcareReports/ShiftChangeLogsReport";
import HistoricalVisitsSummaryReport from "./HomeHealthcareReports/HistoricalVisitsSummaryReport";
import IncompleteShiftsReport from "./HomeHealthcareReports/IncompleteShiftsReport";

export default function HomeHealthcare_Reports(props) {
    const [activeKey, setActiveKey] = useState("homeVisits");
    const [startDate, setStartDate] = useState(moment().startOf('month'));
    const [endDate, setEndDate] = useState(moment().endOf('month'));

    const handleKeyChange = (event, activeKey) => {
        setActiveKey(activeKey);
    };

    useEffect(() => {
        setActiveKey(props.activeSubKey)
    }, [props.activeSubKey]);

    return (
        <div style={{ width: '100%', position: 'absolute' }}>
            <div>
                <Typography
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.5rem",
                        fontFamily: "Lato",
                        marginBottom: 10,
                        marginLeft: 10
                    }}
                >
                    Home Healthcare Reports
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <Tabs
                    value={activeKey}
                    onChange={handleKeyChange}
                    variant="scrollable"
                    sx={{
                        borderBottom: 1,
                        borderColor: 'divider',
                        '& .Mui-selected': {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                        },
                        width: 'inherit'
                    }}
                >
                    {<Tab key={"homeVisits"} value={"homeVisits"} label="Home Visits" />}
                    {<Tab key={"historicalVisitsSummary"} value={"historicalVisitsSummary"} label="Historical Visits Summary" />}
                    {<Tab key={"shiftChangeLogs"} value={"shiftChangeLogs"} label="Shift Change Logs" />}
                    {<Tab key={"incompleteShifts"} value={"incompleteShifts"} label="Incomplete Shifts" />}
                </Tabs>

                <div style={{ width: '100' }}>
                    {activeKey === "homeVisits" && <HomeVisitsReport {...props} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />}
                    {activeKey === "historicalVisitsSummary" && <HistoricalVisitsSummaryReport {...props} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />}
                    {activeKey === "shiftChangeLogs" && <ShiftChangeLogsReport {...props} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />}
                    {activeKey === "incompleteShifts" && <IncompleteShiftsReport {...props} startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} />}
                </div>
            </div>
        </div>
    )
};